import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
type Testimonial = {
  initials: string;
  name: string;
  location: string;
  plan: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  initials: 'SR',
  name: 'Silvia R.',
  location: 'Buenos Aires',
  plan: 'Megapack Completo',
  quote: 'Pensé que nunca más iba a poder comer una factura en el desayuno. Hoy las hago yo misma y nadie nota que son saludables.'
}, {
  initials: 'GM',
  name: 'Graciela M.',
  location: 'Córdoba',
  plan: 'Megapack Completo',
  quote: 'Lo intenté mil veces con recetas de internet y siempre quedaba seco y feo. Con este método salió perfecto la primera vez.'
}, {
  initials: 'PL',
  name: 'Patricia L.',
  location: 'Rosario',
  plan: 'Megapack + Masterclass',
  quote: 'Mi marido ni se dio cuenta que era sin azúcar. Se comió tres galletas sin chistar.'
}];
export function TestimoniosQuick() {
  return <section className="py-14 px-4 bg-brand-ink border-t border-brand-gold/15 relative overflow-hidden" data-id="element-275">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-276"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-277">
        {/* Stats row */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 pb-10 border-b border-brand-gold/15" data-id="element-278">
          {[{
          num: '+400',
          label: 'recetas incluidas'
        }, {
          num: '6',
          label: 'Tomos listos'
        }, {
          num: '6',
          label: 'Bonos incluidos'
        }, {
          num: '4.9',
          label: 'calificación ⭐'
        }].map((s, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-279">
              <span className="font-display text-3xl sm:text-5xl font-bold text-brand-gold leading-none mb-2 glow-gold" data-id="element-280">
                {s.num}
              </span>
              <span className="text-xs sm:text-sm font-medium text-brand-cream/75" data-id="element-281">
                {s.label}
              </span>
            </div>)}
        </div>

        <div className="text-center mb-10" data-id="element-282">
          <p className="text-xs sm:text-sm font-bold text-brand-gold tracking-[0.22em] uppercase mb-2 glow-gold" data-id="element-283">
            ❤️ Testimonios reales
          </p>
          <h2 className="font-display font-extrabold text-brand-cream text-[24px] sm:text-[34px] max-w-[24ch] mx-auto tracking-tight glow-deep leading-tight" data-id="element-284">
            Mujeres que ya volvieron a comer sin miedo
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-7" data-id="element-285">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-base/60 backdrop-blur-sm p-6 rounded-2xl border border-brand-gold/20 flex flex-col items-center text-center" style={{
          boxShadow: '0 12px 30px -12px rgba(212, 168, 67, 0.18), inset 0 1px 0 rgba(212, 168, 67, 0.08)'
        }} data-id="element-286">
              <div className="flex gap-1 mb-3 text-brand-gold justify-center" data-id="element-287">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" strokeWidth={0} data-id="element-288" />)}
              </div>
              <p className="text-brand-cream/85 italic mb-5 text-sm leading-relaxed" data-id="element-289">
                <span className="text-brand-gold font-bold" data-id="element-290">"</span>
                {t.quote}
                <span className="text-brand-gold font-bold" data-id="element-291">"</span>
              </p>
              <div className="gold-divider w-2/3 mb-4" data-id="element-292"></div>
              <div className="flex flex-col items-center gap-2" data-id="element-293">
                <div className="w-11 h-11 rounded-full bg-brand-gold text-brand-base flex items-center justify-center font-extrabold text-sm" data-id="element-294">
                  {t.initials}
                </div>
                <div data-id="element-295">
                  <p className="font-extrabold text-sm text-brand-gold glow-gold" data-id="element-296">
                    {t.name}
                  </p>
                  <p className="text-xs text-brand-cream/65 mt-0.5" data-id="element-297">
                    📍 {t.location}
                  </p>
                  <p className="text-[11px] text-brand-gold/80 mt-0.5 italic" data-id="element-298">
                    {t.plan}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}